(function($) {

  $(document).ready(function() {

    $('body').on('click','.patmos-pdf', function (e) {

      e.preventDefault();

      let button = $(this);
      let file_url = button.data('url');

      $.ajax({
        type: 'POST',
        url : LehtiAjax.ajaxurl,
        dataType: 'html',
        data : {
          action: 'populate_pdf_modal',
          fileUrl: file_url
        },
        success: function( data ) {

          var pdfModal = new tingle.modal({
            onOpen: function() {
              location.hash = 'lehti';
            },
            onClose: function () {
                pdfModal.destroy();
            }

          });

          pdfModal.setContent(data);
          pdfModal.open();

          window.onhashchange = function() {
            if (location.hash === '') {
                pdfModal.destroy();
            }
          };

        },
        error: function( data ) {
          alert("An error occured: " + data.status + " " + data.statusText);
        }
      });

    });

  });

})(jQuery);
